"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClaimsTableRow = exports.ClaimsTableRowPlain = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var moment = require("moment");
var components_1 = require("@athena-portal/components");
var MotorClaim_1 = require("../../model/MotorClaim");
var SupportPortalTemplates_1 = require("../../SupportPortalTemplates");
var services_1 = require("@falcon/services");
var RentersClaim_1 = require("../../model/RentersClaim");
var ClaimsTableRowPlain = /** @class */ (function (_super) {
    __extends(ClaimsTableRowPlain, _super);
    function ClaimsTableRowPlain() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ClaimsTableRowPlain.prototype.render = function () {
        var _this = this;
        var claim = this.props.claim;
        return ((0, jsx_runtime_1.jsxs)("tr", { className: "on-hover-pointer", onClick: function () { return _this.navigateToClaimUpdate("/customers/".concat(_this.props.clientReferenceNumber, "/claims/").concat(_this.props.claim.id)); }, children: [(0, jsx_runtime_1.jsx)("td", { children: claim.id }), SupportPortalTemplates_1.SupportPortalTemplates.getProductByClaim(claim) === services_1.ProductsEnum.MOTOR && (0, jsx_runtime_1.jsx)("td", { children: MotorClaim_1.default.getClaimType(claim.claimTypeId) }), SupportPortalTemplates_1.SupportPortalTemplates.getProductByClaim(claim) === services_1.ProductsEnum.RENTERS && (0, jsx_runtime_1.jsx)("td", { children: RentersClaim_1.default.getClaimType(claim.claimTypeId) }), (0, jsx_runtime_1.jsx)("td", { children: moment(claim.incidentDate).format("DD/MM/YYYY") }), (0, jsx_runtime_1.jsx)("td", { children: claim.anyClaimSpend ? "yes" : "no" }), (0, jsx_runtime_1.jsx)("td", { children: claim.refundAllowed ? "yes" : "no" })] }));
    };
    ClaimsTableRowPlain.prototype.navigateToClaimUpdate = function (href) {
        this.props.navigate(href, {
            state: {
                selectedDriver: this.props.selectedDriver
            }
        });
    };
    ClaimsTableRowPlain = __decorate([
        components_1.authorize
    ], ClaimsTableRowPlain);
    return ClaimsTableRowPlain;
}(React.Component));
exports.ClaimsTableRowPlain = ClaimsTableRowPlain;
exports.ClaimsTableRow = (0, components_1.withRouter)(ClaimsTableRowPlain);
//# sourceMappingURL=ClaimsTableRow.js.map